module.exports = __webpack_public_path__ + "img/payments.weekly.c0ae079c.png";